/**
 * External Imports
 */
import { FC, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';

/**
 * Nexus Imports
 */
import { NeuFeedback } from '@neutron/react';

interface ILoadingProps {
  centered?: boolean;
  extendedTimeOut?: boolean;
  label?: string;
  size?: 'default' | 'small' | 'large' | undefined;
}

const Loading: FC<ILoadingProps> = ({
  centered = true,
  label = '',
  extendedTimeOut = false,
  size = 'default'
}) => {
  const navigate = useNavigate();
  useEffect(() => {
    const loadingTimeout = setTimeout(
      () => {
        // Loading timeout will redirect to offline page
        navigate('/404');
      },
      extendedTimeOut ? 35000 : 20000
    );
    return () => clearInterval(loadingTimeout);
  }, []);

  return (
    <div className="d-flex flex-column center-content__col--top-spacing neu-text-center w-100 h-100">
      <div className="d-flex h-100" style={{ marginTop: '-2rem' }}>
        <div
          className={`d-flex w-100 flex-column${
            centered ? ' justify-content-center' : ''
          }`}
        >
          <NeuFeedback
            className="mt-n2"
            data-testid="loading-component"
            kind="spinner"
            label={label ? `Loading ${label}...` : 'Loading...'}
            role="status"
            size={size}
          />
        </div>
      </div>
    </div>
  );
};

export default Loading;
